import axiosInstance from "./AxiosInstance";

export const postContactQuery = (body) => {
  return axiosInstance.post(`v1/contact`, body);
};

export const getContactQueries = () => {
  return axiosInstance.get(`v1/contact`);
};
